import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import * as rsdActions from './rsd.actions';
import produce from 'immer';

import { RsdState } from './rsd.model';
import { DatasetSubtype } from '@app/modules/core/store/models/dataset.model';

export const rsdFeatureKey = 'rsd';

export const initialRsdState: RsdState = {
  selectedDocumentStack: [],
  ui: {
    isDrawerOpen: false,
    isEdit: false,
    isNew: false
  },
  relatedDatasets: null,
//  relatedDocuments: null,
  relatedDocumentCountsByDataset: null,
  newRelatedDocument: null
};

export const reducer: ActionReducer<RsdState, Action> = createReducer(
  initialRsdState,
  on(rsdActions.pushDocumentStateStack, (state, action) => {
    const { dataset, layer, document, editView, isDrawerOpen, replaceStack, edit, backAction } = action;

    const selectedDocumentStack = [...(replaceStack ? [] : state.selectedDocumentStack)];

    selectedDocumentStack.push({
      dataset,
      layer,
      document,
      editView,
      backAction
    });

    return {
      ...state,
      selectedDocumentStack,
      ui: {
        ...state.ui,
        isNew: false,
        isEdit: edit === true,
        isDrawerOpen
      }
    };
  }),
  on(rsdActions.popDocumentStateStack, (state, action) => {
    const selectedDocumentStack = [...state.selectedDocumentStack];

    if (selectedDocumentStack.length > 0) {
      selectedDocumentStack.pop();
    }

    return {
      ...state,
      selectedDocumentStack,
      ui: {
        ...state.ui,
        isEdit: false
      }
    };
  }),
  on(rsdActions.editDocument, (state, action) => {
    return {
      ...state,
      ui: {
        ...state.ui,
        isEdit: true
      }
    };
  }),
  on(rsdActions.cancelEditDocument, (state, action) => {
    return {
      ...state,
      ui: {
        ...state.ui,
        isEdit: false
      }
    };
  }),
  on(rsdActions.setNewDocumentToStore, (state, action) => {
    return {
      ...state,
      selectedDocumentStack: [],
      ui: {
        ...state.ui,
        isDrawerOpen: true,
        isNew: true
      }
    };
  }),
  on(rsdActions.cancelNewDocument, (state, action) => {
    return {
      ...state,
      selectedDocumentStack: [],
      ui: {
        ...state.ui,
        isDrawerOpen: false,
        isEdit: false,
        isNew: false
      }
    };
  }),

  on(rsdActions.saveDocumentComplete, (state, action) => {
    const { document } = action;

    const selectedDocumentStack = produce(state.selectedDocumentStack, draft => {
      if (draft.length > 0) {
        draft[draft.length - 1].document = document;
      }
    });

    return {
      ...state,
      selectedDocumentStack,
      ui: {
        ...state.ui,
        isEdit: false,
        isNew: false
      }
    };
  }),
  on(rsdActions.hideDrawer, (state, action) => {
    const { clearDocumentStack } = action;

    const selectedDocumentStack = clearDocumentStack ? [] : state.selectedDocumentStack;
    return {
      ...state,
      selectedDocumentStack,
      ui: {
        ...state.ui,
        isEdit: false,
        isNew: false,
        isDrawerOpen: false
      }
    };
  }),
  on(rsdActions.showDrawer, (state, action) => {
    return {
      ...state,
      ui: {
        ...state.ui,
        isDrawerOpen: true
      }
    };
  }),
  on(rsdActions.transitionWorkflowComplete, (state, action) => {
    const { document } = action;

    const selectedDocumentStack = produce(state.selectedDocumentStack, draft => {
      if (!!!draft || draft.length === 0) {
        return;
      }
      const docState = draft[draft.length - 1];
      docState.document = {
        ...document
      };
    });

    return {
      ...state,
      selectedDocumentStack,
      ui: {
        ...state.ui,
        isEdit: false
      }
    };
  }),

  // related docs
  on(rsdActions.initRelatedDocumentComplete, (state, action) => {
    return {
      ...state,
      newRelatedDocument: action.document
    };
  }),

/*  on(rsdActions.setRelatedDocumentsComplete, (state, action) => {
    return {
      ...state,
      relatedDocuments: action.documents
    };
  }),
*/
  on(rsdActions.setRelatedDocumentCountsByDatasetComplete, (state, action) => {
    return {
      ...state,
      relatedDocumentCountsByDataset: action.results?.filter(
        r => r.targetDatasetSubtype !== DatasetSubtype.Timeline && r.targetDatasetSubtype !== DatasetSubtype.InvolvedParty
      )
    }
  }),

  on(rsdActions.loadRelatedDatasetsComplete, (state, action) => {
    return {
      ...state,
      relatedDatasets: action.datasets
    };
  }),
  on(rsdActions.setCurrentDocumentState, (state, action) => {
    const { dataset, document } = action;

    const selectedDocumentStack = produce(state.selectedDocumentStack, draft => {
      if (draft.length > 0) {
        draft[draft.length - 1].dataset = dataset;
        draft[draft.length - 1].document = document;
      }
    });
    return {
      ...state,
      selectedDocumentStack
    };
  }),

  on(rsdActions.translateSelectedDocumentComplete, (state, action) => {
    const { document, fromCode, toCode } = action;

    const selectedDocumentStack = produce(state.selectedDocumentStack, draft => {
      if (draft.length > 0) {
        draft[draft.length - 1].document = document;
        draft[draft.length - 1].translatedFrom = fromCode;
        draft[draft.length - 1].translatedTo = toCode;
      }
    });
    return {
      ...state,
      selectedDocumentStack
    };
  })
);

export const getSelectedDocumentState = (state: RsdState) =>
  state?.selectedDocumentStack?.length > 0 ? state.selectedDocumentStack[state.selectedDocumentStack.length - 1] : null;
export const getIsDrawerOpen = (state: RsdState) => state?.ui?.isDrawerOpen;
export const getIsEdit = (state: RsdState) => state?.ui?.isEdit;
export const getIsNew = (state: RsdState) => state?.ui?.isNew;
export const getSelectedDocumentStackCount = (state: RsdState) => state?.selectedDocumentStack?.length;
export const getSelectedDocumentStack = (state: RsdState) => state?.selectedDocumentStack;

// related docs
export const getRelatedDatasets = (state: RsdState) => state.relatedDatasets;
//export const getRelatedDocuments = (state: RsdState) => state.relatedDocuments;
export const getNewRelatedDocument = (state: RsdState) => state.newRelatedDocument;
export const getRelatedDocumentCountsByDataset = (state: RsdState) => state.relatedDocumentCountsByDataset;
